export const itemsPerPage = 25;
export const itemsRange = [1, 10, 25, 100];
